import { Dropdown, Option, mergeClasses } from '@fluentui/react-components';
import { fieldMeetCertainCriteriaRelationshipInputStyles } from './styles';
import { useMemo } from 'react';
import { ConditionItemType, FieldMeetCertainCriteriaType } from '../../types';
import { useAutomationRuleConditions } from '../../use-conditions';

interface Props {
	conditionId: string;
}

const relationshipOptions = [
	{
		label: 'Any',
		value: 'any',
	},
	{
		label: 'All',
		value: 'all',
	},
];

export default function FieldMeetCertainCriteriaRelationshipCheckInput(props: Props) {
	const classes = fieldMeetCertainCriteriaRelationshipInputStyles();
	const {conditions, setConditions} = useAutomationRuleConditions();

	const value = useMemo(() => {
		const foundCondition = conditions.find(item => item.id === props.conditionId) as ConditionItemType;
		const relationshipCheck = foundCondition!.fieldMeetCertainCriteria!.relationshipCheck;
		return relationshipOptions.find(item => item.value === relationshipCheck)?.label || '';

	}, [conditions, props.conditionId]);
  
	return (
		<>
			<Dropdown
				className={mergeClasses(
					classes.dropdown,
					classes.conditionTypeDropdown,
				)}
				listbox={{
					style: {
						minWidth: 'fit-content'
					}
				}}
				appearance='underline'
				placeholder='Relationship check'
				positioning="below-start"
				defaultValue='all'
				value={value}
				onOptionSelect={async (_, data) => {
					setConditions((oldValues) => {
						return oldValues.map((item) => {
							if (item.id === props.conditionId) {
								return {
									...item,
									fieldMeetCertainCriteria: {
										...item.fieldMeetCertainCriteria as FieldMeetCertainCriteriaType,
										relationshipCheck: data.optionValue as 'any' | 'all',
									},
								};
							}

							return item;
						});
					});
				}}
			>
				{relationshipOptions.map((option) => (
					<Option key={option.value} value={option.value}>{option.label}</Option>
				))}
			</Dropdown>
		</>
	);
}